module.exports = __webpack_public_path__ + "static/media/favicon.09be5230.png";